export interface Option<T = false> {
  Some?: T
  None?: boolean
}

export interface Some<T> {
  data: T
}

export interface Options {
  some: <T>(some: T) => Option<T>
  none: () => Option<false>
}

const some = <T>(some: T): Option<T> => {
  return { Some: some, None: false }
}

const none = (): Option => {
  return { None: true }
}

export default { some, none } as Options
